var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43694 2L2 3.43694L2.73376 4.1707L4.54777 6.01529L2.73376 7.8293L2 8.53248L3.43694 10L4.1707 9.26624L6.01529 7.42166L7.8293 9.26624L8.53248 10L10 8.53248L9.26624 7.8293L7.42166 6.01529L9.26624 4.1707L10 3.43694L8.53248 2L7.8293 2.73376L6.01529 4.54777L4.1707 2.73376L3.43694 2Z",
    fill: "#7D94AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXClose);
export default __webpack_public_path__ + "static/media/icon-x-close.8f84200df2c7f742b9c6db6472215a6d.svg";
export { ForwardRef as ReactComponent };